import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { AbstractControl, FormControl } from '@angular/forms';
import { GlobalFormGroup } from '@app/services/formulario';
import { convertErrorsNz } from '@app/utiles/ng-zorro';
import { BehaviorSubject, debounceTime, Subject, takeUntil } from 'rxjs';

type ISelect <T> = T & {
  disabled?: boolean;
}
@Component({ standalone: false, selector: 'app-form-reactive-select',
  templateUrl: './reactive-select.component.html',
})
export class FormReactiveSelect<T, K> implements OnInit, OnDestroy {
  @Input() label: string = '';
  @Input() required = false;
  @Input() labelClass: string = '';
  @Input() secondLabel: string = '';
  @Input() secondLabelClass: string = '';
  @Input() inputFormControl: GlobalFormGroup<T> = null;
  @Input() selects: ISelect<K>[] = [];
  @Input() placeHolder: string = '';
  @Input() multiple = false;
  @Input() valueSelect: string = 'value';
  @Input() funcLabelSelect: (obj: K) => string;
  @Input() labelSelect: string = 'label';
  @Input() disabledSelect: string = 'disabled';
  @Input() tooltipSelect: string = 'tooltip';
  @Input() allowClear: boolean = false;

  @Input() loading = false;
  @Input() textContent: string = null;
  @Output() changeSelect = new EventEmitter<K>();
  @Output() onLoadMore = new EventEmitter<boolean>();
  @Input() selectorDisabled = false;
  @Input() debounce = 800;
  @Input() filterDropdown = true;
  @Output() readonly onSearchEvent = new EventEmitter();

  readonly searchChange$ = new BehaviorSubject('');
  private readonly destroy$ = new Subject<void>();

  readonly convertErrorsNz = convertErrorsNz;
  // Necesario para evitar el error de tipado para [formControl] (https://github.com/ngx-formly/ngx-formly/issues/2842)
  readonly asFormControl = (formControl: AbstractControl): FormControl => formControl as FormControl;
  trackBySelect = (index: number, select: ISelect<K>): string | number => select?.[this.valueSelect] ?? index;
  get labelAndLabelFuncSelect() {
    return this.funcLabelSelect ? this.funcLabelSelect : (select: K) => select[this.labelSelect];
  }

  loadMore() {
    this.onLoadMore.emit(true);
  }

  onSearch(event: string) {
    this.searchChange$.next(event);
  }

  ngOnInit(): void {
    this.inputFormControl.valueChanges.pipe(takeUntil(this.destroy$)).subscribe((value) => {
      this.inputFormControl.markAsDirty();
      this.changeSelect.emit(this.selects.find((select) => select[this.valueSelect] === value));
    });

    this.searchChange$.pipe(debounceTime(this.debounce), takeUntil(this.destroy$)).subscribe((busqueda) => this.onSearchEvent.emit(busqueda));
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    this.searchChange$.complete();
  }
}
